export const FEATURE_TITRES_DETENTION = 'feature_titres_detention';
export const FEATURE_EDITER_CEAF = 'feature_editer_ceaf';
export const FEATURE_AUTORISATION_ACQUISITION_DETENTION =
    'feature_autorisation_acquisition_detention';

export const FEATURE_DEMANDER_SUPPRESSION_ARME = 'feature_demander_suppression_arme';
export const FEATURE_CREER_COMPTE_DETENTEUR_LICENCIEE = 'feature_creer_compte_detenteur_licencie';
export const FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER =
    'feature_autorisation_fonctionnalites_compte_detenteur_heritier';
export const FEATURE_CAPTCHA = 'feature_captcha';
export const FEATURE_CAPTCH_ETAT = 'feature_captch_etat';
export const FEATURE_RENOMMAGE_PERSONA_DETENTEUR_HERITEE_TROUVEE =
    'feature_renommage_persona_detenteur_heritee_trouvee';

export const FEATURE_APPEL_API_FFBT = 'feature_appel_api_ffbt';
export const FEATURE_APPEL_API_FFTIR = 'feature_appel_api_fftir';

/**
 * @param featureData à récuperer dans le store dans store.featureFlipping.data
 * @param featureName il faut utiliser les constantes
 * @returns bool isActive
 */
export const isFeatureActive = (featureData, featureName) => {
    return featureData[featureName];
};
